import sileo from 'sileo';

const MessageSequence = new sileo.Model('marketing', 'message-sequence');


const actions = {
    updateMessageSequence(context, data) {
        const filters = { 'id': data.id };
        const form = new FormData();
        form.append('is_active', data.isActive);
        return MessageSequence.objects.update(filters, form);
    },

    fetchMessageSequence(context, filters) {
        return MessageSequence.objects.filter(filters);
    }
};

export default {
    namespaced: true,
    actions
};
